<ng-container *ngIf="actions.length < (maxInlineActions ? maxInlineActions : 3); else flyout">
  <ng-container *ngFor="let action of actions">
    <ng-container *ngIf="action.link && action.link(item, action); else button">
      <a
        *ngIf="!action.hidden || (action?.hidden && !action.hidden(item, action))"
        [matTooltip]="action?.tooltip ?? ''"
        [disabled]="action.disabled && action.disabled(item, action)"
        [ngClass]="{ disabled: action.disabled && action.disabled(item, action) }"
        mat-icon-button
        [routerLink]="action.link(item, action)"
        [queryParams]="action?.linkQueryParams && (action?.linkQueryParams(item, action) ?? null)"
        [target]="action.linkTarget ?? '_self'"
        (click)="$event.stopPropagation()"
        [queryParamsHandling]="action?.queryParamsHandling ?? ''"
      >
        <mat-icon class="text-theme-gray" [ngClass]="action.iconClass">{{ action.icon }}</mat-icon>
      </a>
    </ng-container>
    <ng-template #button>
      <button
        *ngIf="!action.hidden || (action?.hidden && !action.hidden(item, action))"
        [matTooltip]="action?.tooltip ?? ''"
        [disabled]="action.disabled && action.disabled(item, action)"
        mat-icon-button
        (click)="$event.stopPropagation(); actionClick.emit(action)"
      >
        <mat-icon class="text-theme-gray" [ngClass]="action.iconClass">{{ action.icon }}</mat-icon>
      </button>
    </ng-template>
  </ng-container>
</ng-container>

<ng-template #flyout>
  <button mat-icon-button [matMenuTriggerFor]="menu" (click)="$event.stopPropagation()">
    <mat-icon>more_horiz</mat-icon>
  </button>

  <mat-menu #menu="matMenu">
    <ng-container *ngFor="let action of actions">
      <ng-container *ngIf="action.link && action.link(item, action); else button">
        <a
          *ngIf="!action.hidden || (action.hidden && !action.hidden(item, action))"
          [disabled]="!!isLoading || (action.disabled && action.disabled(item, action))"
          [ngClass]="{ disabled: action.disabled && action.disabled(item, action) }"
          mat-menu-item
          [routerLink]="action.link(item, action)"
          [queryParams]="action?.linkQueryParams && (action?.linkQueryParams(item, action) ?? null)"
          [target]="action.linkTarget ?? '_self'"
          (click)="$event.stopPropagation()"
          [queryParamsHandling]="action?.queryParamsHandling ?? ''"
        >
          <mat-icon class="text-theme-gray" [ngClass]="action.iconClass">{{ action.icon }}</mat-icon>
          <span *ngIf="action.label">{{ action.label }}</span>
        </a>
      </ng-container>
      <ng-template #button>
        <button
          *ngIf="!action.hidden || (action.hidden && !action.hidden(item, action))"
          [disabled]="!!isLoading || (action.disabled && action.disabled(item, action))"
          mat-menu-item
          (click)="$event.stopPropagation(); actionClick.emit(action)"
        >
          <mat-icon class="text-theme-gray" [ngClass]="action.iconClass">{{ action.icon }}</mat-icon>
          <span *ngIf="action.label">{{ action.label }}</span>
        </button>
      </ng-template>
    </ng-container>
  </mat-menu>
</ng-template>
